module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-scores-wrapper"
  }, _vm._l((_vm.riskData), function(year) {
    return _c('year-column', {
      key: year.year,
      attrs: {
        "yearData": year,
        "catIndex": _vm.catIndex
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e60f070","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/heat-map-graphic/CategoryScoresRow.vue
// module id = 548
// module chunks = 1